import React, { useEffect } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getUser } from "../../../features/userManagement/getParticularUserSlice";
// import Input from '../../form-components/Input';
import AddUserForm from "../user-forms/AddUserForm";
import EditUserForm from "../user-forms/EditUserForm";

const AddUserModal = ({
  toggleFunction = () => { },
  isVisible = true,
  userId = "",
  isFromAllUsers,
  setCurrentActiveTab
}) => {
  // const [toggleChecked, setToggleChecked] = useState(false);
  let projectData = JSON.parse(localStorage.getItem("_user"));

  const dispatch = useDispatch();

  useEffect(() => {
    userId && dispatch(getUser({ userId: userId, organization_uuid: projectData?.organizations[0].uuid }));
  }, [userId]);

  return (
    <Modal
      data-bs-keyboard="false"
      onHide={toggleFunction}
      show={isVisible}
      className="add-organization-popup add-user-modal"
      centered={true}
      dialogClassName="common-modal"
    >
      <ModalHeader closeButton onHide={toggleFunction}>
        <h3 className="modal-title" id="Add_OrganizationLabel">
          {userId ? "Edit" : "Add"} User
        </h3>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          {userId ? (
            <EditUserForm
              toggleFunction={toggleFunction}
              userId={userId}
              isFromAllUsers={isFromAllUsers}
              setCurrentActiveTab={setCurrentActiveTab}
            />
          ) : (
            <AddUserForm
              toggleFunction={toggleFunction}
              setCurrentActiveTab={setCurrentActiveTab}
            />
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddUserModal;
